export const clearApiCallState = (type: string) => ({ type: `${type}Clear` })
export const clearAllApiCallState = () => ({ type: "clearAllApiCallState" });